export default "__VITE_ASSET__dQ6RfEXg__"